// PromptContext.jsx
import React, { createContext, useState, useContext } from 'react';
import { PromptDialog } from './PromptDialog';

const PromptContext = createContext();

export const usePrompt = () => {
    return useContext(PromptContext);
};

export const PromptProvider = ({ children }) => {
    const [promptState, setPromptState] = useState({
        open: false,
        title: '',
        label: '',
        defaultValue: '',
        resolve: null,
        reject: null,
        isSecret: false,
        confirmText: undefined,
        cancelText: undefined,
        disableMultiline: undefined,
    });
    const showPrompt = ({ title, label, defaultValue = '', confirmText,  cancelText, disableMultiline, isSecret}) => {
        return new Promise((resolve, reject) => {
            setPromptState({
                open: true,
                title,
                label,
                defaultValue,
                resolve,
                reject,
                confirmText,
                cancelText,
                disableMultiline,
                isSecret
            });
        });
    };

    const handleConfirm = (value) => {
        if (promptState.resolve) {
            promptState.resolve(value);
        }
        setPromptState({
            ...promptState,
            open: false,
            resolve: null,
            reject: null,
        });
    };

    const handleCancel = () => {
        if (promptState.resolve) promptState.resolve(null);
        setPromptState({
            ...promptState,
            open: false,
            resolve: null,
            reject: null,
        });
    };

    return (
        <PromptContext.Provider value={showPrompt}>
            {children}
            <PromptDialog
                {...promptState}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
            />
        </PromptContext.Provider>
    );
};